import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { PlannerEcsSystem, ProductInfoComponent, ProductType } from '@inter-ikea-storageone/range';
/**
 * The 350cm deep cloth rail comes in all frame colors while the 580cm deep cloth rail only comes in white and grey.
 * To be able to drag the 580cm cloth rail to a 350cm deep frame, the 580cm cloth rails has all similar colors of the 350cm cloth rail as
 * auto adapt variants. If it autoadapts to another color than the frame color this system will change it to the correct color.
 */
export class AutoAdaptClothRailSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'AutoAdaptClothRailSystem', ComponentIds.AUTO_ADAPT_SESSION_COMPONENT_ID);
        this.systemsAfterMe = ['AutoAdaptCacheSystem'];
        this.clothRailProducts = [];
    }
    setMarketProducts(marketProducts) {
        this.clothRailProducts = marketProducts.filter(p => [ProductType.PAX_CLOTH_RAIL_350].includes(p.type));
    }
    onAdd() { }
    onUpdate() { }
    onRemove(entity) {
        if (!this.coreApi.entities.isProductType(entity, ProductType.PAX_CLOTH_RAIL_350)) {
            return;
        }
        const autoAdaptVariantComponent = entity.getComponent(ComponentIds.AUTO_ADAPT_VARIANT_COMPONENT_ID);
        if (autoAdaptVariantComponent && autoAdaptVariantComponent.originalEntity.id !== entity.id) {
            // If entity id is not the same as the original entity id in autoAdaptVariantComponent, an autoadapt of the cloth rail has occured
            const frameColor = HierarchyUtils.parent(entity)?.getComponent(ProductInfoComponent.id)?.design;
            const clothRailColor = entity.getComponent(ProductInfoComponent.id)
                ?.design;
            if (frameColor !== clothRailColor) {
                // If cloth rail has autoadapted to other color than fram color, change the cloth rail to same color as frame
                const clothRailSize = this.coreApi.entities.getEntityComSize(entity);
                const clothRail = this.clothRailProducts.find(c => c.design === frameColor &&
                    c.communicatedDimensions.width === clothRailSize?.width &&
                    c.communicatedDimensions.depth === clothRailSize?.depth);
                clothRail && this.coreApi.products.removeAndAdd(entity.id, clothRail.coreProductId);
            }
        }
    }
}
//# sourceMappingURL=AutoAdaptClothRailSystem.js.map